module.exports = __webpack_public_path__ + "img/figure-10@1x.webp";